import axios from "axios";
import Vue from "vue";
import store from "./store";
import analytics from "./analytics";

// Make EmblaCarousel available globally for vanilla JS use
import EmblaCarousel from "embla-carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
window.EmblaCarousel = EmblaCarousel;
window.WheelGesturesPlugin = WheelGesturesPlugin;

// Global components
Vue.component("loader-container", () => import("./components/loaderContainer"));

// Bootstrap-Vue
import { BootstrapVue } from "bootstrap-vue";
Vue.use(BootstrapVue);

import VueSweetalert2 from "vue-sweetalert2";
Vue.use(VueSweetalert2);

// Validation
import VeeValidate, { Validator } from "vee-validate";
import de from "vee-validate/dist/locale/de";
Vue.use(VeeValidate, {
    events: "change",
    locale: "de",
    inject: true,
    fieldsBagName: "validationFields",
    errorBagName: "validationErrors",
    dictionary: {
        de: de,
    },
});

Validator.extend("phone_number", {
    validate: (value) => {
        const validCodes = [
            "015019",
            "015020",
            "01511",
            "01512",
            "01514",
            "01515",
            "01516",
            "01517",
            "015180",
            "015181",
            "015310",
            "01520",
            "01521",
            "01522",
            "01523",
            "01525",
            "01526",
            "01529",
            "015510",
            "015511",
            "015566",
            "015630",
            "015678",
            "015679",
            "01570",
            "01573",
            "01575",
            "01577",
            "01578",
            "01579",
            "015888",
            "01590",
            "0160",
            "0162",
            "0163",
            "0170",
            "0171",
            "0172",
            "0173",
            "0174",
            "0175",
            "0176",
            "0177",
            "0178",
            "0179",
            "0151",
            "0152",
            "0157",
            "0159",
        ];

        const cleanedValue = value.replace(/\s|-/g, "");

        const countryCodeLength = 3;
        const code = cleanedValue.substr(countryCodeLength, 6);
        const validCode = validCodes.find((validCode) =>
            code.startsWith(validCode)
        );
        return validCode !== undefined;
    },
    message: "Phone number incorrect",
});
import VeeValidateLaravel from "vee-validate-laravel";
Vue.use(VeeValidateLaravel);

// js routing
import { ZiggyVue } from "ziggy";
import { Ziggy } from "ziggyRoutes";
Vue.use(ZiggyVue, Ziggy);

// Components
Vue.component("app", () => import("./components/App"));

Vue.component("mobile-header", () => import("./components/MobileHeader"));

Vue.component("gift-card-list", () => import("./components/GiftCardList"));

Vue.component("scroll-landing", () => import("./components/ScrollLanding.vue"));

Vue.component("slider-city", () => import("./components/SliderCity.vue"));

Vue.component("top-up-card", () => import("./components/TopUpCard.vue"));

Vue.component("gift-card-one", () => import("./components/GiftCardOne"));

Vue.component("gift-card-to-cart", () => import("./components/GiftCardToCart"));

Vue.component("gift-card-to-cart-modal", () =>
    import("./components/GiftCardToCartModal")
);

Vue.component("gift-card-cart", () => import("./components/GiftCardCart"));

Vue.component("gift-card-cart-informer", () =>
    import("./components/GiftCardCartInformer")
);

Vue.component("gift-card-checkout", () =>
    import("./components/GiftCardCheckout")
);

Vue.component("gift-card-checkout-email-confirmation-popup", () =>
    import("./components/GiftCardCheckoutEmailConfirmationPopup.vue")
);

Vue.component("gift-card-top-up-checkout", () =>
    import("./components/GiftCardTopUpCheckout")
);

Vue.component("gift-card-checkout-finish", () =>
    import("./components/GiftCardCheckoutFinish")
);

Vue.component("gift-card-redemption", () =>
    import("./components/GiftCardRedemption")
);

Vue.component("voucher-list", () => import("./components/VoucherList"));

Vue.component("voucher-promo", () => import("./components/VoucherPromo"));

Vue.component("voucher-choose", () => import("./components/VoucherChoose"));

Vue.component("voucher-order", () => import("./components/VoucherOrder"));

Vue.component("purchase-gift-card-form", () =>
    import("./components/PurchaseGiftCardForm")
);

Vue.component("benefits", () => import("./components/benefits"));

Vue.component("photoswipe", () => import("./components/PhotoSwipe"));

Vue.component("carousel", () => import("./components/Carousel"));

Vue.component("slider", () => import("./components/Slider"));

Vue.component("benefits-calculator", () =>
    import("./components/vouchers/BenefitsCalculator")
);

Vue.component("category-filters", () => import("./components/categoryFilters"));

Vue.component("share-button", () => import("./components/shareButton"));

Vue.component("region-logo-image", () =>
    import("./components/RegionLogoImage")
);

Vue.component("region-images", () => import("./components/RegionImages"));

Vue.component("blog", () => import("./components/blog/Blog"));
Vue.component("events", () => import("./components/events/Events"));
Vue.component("event-locations", () =>
    import("./components/events/EventLocations")
);
Vue.component("events-brief", () => import("./components/events/EventsBrief"));
Vue.component("event-banner", () => import("./components/events/EventBanner"));
Vue.component("event-location-grid", () =>
    import("./components/events/EventLocationGrid")
);
Vue.component("vouchers-slider", () =>
    import("./components/blog/VouchersSlider")
);
Vue.component("event-locations-slider", () =>
    import("./components/events/EventLocationsSlider")
);

Vue.component("whatsapp-box", () => import("./components/WhatsappBox"));
Vue.component("whatsapp-service-box", () =>
    import("./components/WhatsappServiceBox")
);

Vue.component("voucher-testimonials", () =>
    import("./components/VoucherTestimonials")
);

Vue.component("b2b-appointment-request-modal", () =>
    import("./components/B2bAppointmentRequestModal.vue")
);

import GmapVue from "gmap-vue";
Vue.use(GmapVue, {
    load: {
        key: window.config.googleApiKey,
        libraries: "places,drawing,visualization", // This is required if you use the Autocomplete plugin
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed='someFunc'>`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'gmap-vue/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then set installComponents to 'false'.
    //// If you want to automatically install all the components this property must be set to 'true':
    installComponents: true,
});

// import MapInfoWindow from './components/MapInfoWindow';
// Vue.component('map-info-window', MapInfoWindow);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their 'basename'.
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */
// const files = require.context('./components/', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

axios.defaults.withCredentials = true;
axios.defaults.baseURL = location.protocol + "//" + location.host + "/api/v1";

Vue.config.productionTip = false;

const app = new Vue({
    el: "#app",
    data() {
        return {
            cityToSelect: null,
        };
    },
    store,
    mounted() {
        analytics.fbPixelEvent("track", "ViewContent");

        setTimeout(() => {
            analytics.fbPixelEvent("trackCustom", "ViewContent10sec");
        }, 10000);

        setTimeout(() => {
            analytics.fbPixelEvent("trackCustom", "ViewContent20sec");
        }, 20000);

        setTimeout(() => {
            analytics.fbPixelEvent("trackCustom", "ViewContent30sec");
        }, 30000);

        if (window.location.search.indexOf("gclid") > -1) {
            analytics.fbPixelEvent("trackCustom", "CampaignClickGoogleAds");
        }

        if (window.location.search.indexOf("utm_source=socialads") > -1) {
            analytics.fbPixelEvent("trackCustom", "CampaignClickSocial");
        }
    },
    methods: {
        confirmCity(city) {
            this.cityToSelect = city;
            this.$refs["modal-city-confirm"].show();
        },
        cancelCity() {
            this.$refs["modal-city-confirm"].hide();
        },
    },
});
